var exports = {
  "kL": "CreateDMBottomSheet.module__container___bHdlRW",
  "XG": "CreateDMBottomSheet.module__scroller___bHdlRW",
  "Qs": "CreateDMBottomSheet.module__content___bHdlRW",
  "h_": "CreateDMBottomSheet.module__description___bHdlRW",
  "ov": "CreateDMBottomSheet.module__friendSelector___bHdlRW",
  "qr": "CreateDMBottomSheet.module__footer___bHdlRW",
  "x7": "CreateDMBottomSheet.module__cancelButton___bHdlRW",
  "Tf": "CreateDMBottomSheet.module__createButton___bHdlRW",
};

module.exports = exports;
